import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import QuotaImportIconSvg from './icon-quota-import.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <QuotaImportIconSvg {...validProps} />;
}
SvgComponent.iconName = 'quotaImportIcon';

export const QuotaImportIcon = svgIconWrapper(SvgComponent);
